import './system-icon.css';

import classNames from 'classnames';
import React from 'react';

interface SystemIconProps {
	icon: {
		svg: string;
	};
	iconColor: string;
	iconSize: number;
}

export function SystemIcon({ icon, iconColor, iconSize }: SystemIconProps) {
	const iconSizeStyle = {
		height: `${iconSize}px`,
		width: `${iconSize}px`,
	};
	const svg = icon?.svg;

	return (
		<div
			className={classNames('svg-container', 'system-icon', iconColor)}
			style={{ ...iconSizeStyle }}
			dangerouslySetInnerHTML={{ __html: svg }}
		/>
	);
}
